// VERFICAR PARA EXCLUIR ESTE ARQUIVO
import React from 'react';
import axios from 'axios';
import urlBase from '../../url-base';
import queryString from 'query-string';
//import pdfRedeCredenciada from '../../components/relatorio/credenciado';


class RelatorioRedeCredenciada extends React.Component {

  constructor(props) {
    super(props);

    this.downloadPDF = this.downloadPDF.bind(this);
    this.openPDF = this.openPDF.bind(this);
  }

  componentDidMount() {
    let param = queryString.parse(window.location.search);
    let uf, idCity, idDistrict, specialties = "-1";
    
    if (param.uf != undefined) {
        uf = param.uf;
    }

    if (param.idCity != undefined) {
      idCity = param.idCity;
    }    
    if (param.idDistrict != undefined) {
      idDistrict = param.idDistrict;
    }   

    if (param.specialties != undefined) {
      specialties = param.specialties;
    } 
    
    let	dataPost = {
      uf         : uf,    
      idCity     : idCity, 
      idDistrict : idDistrict,
      specialties: specialties
    };

    axios.post(urlBase.loopBack + 'APIS4s/RedeAtendimento' , dataPost)
    .then((result) => {
   
      if (param.opcao==0)
         this.openPDF(result.data);  
      else if (param.opcao==1) {
        this.downloadPDF(result.data);

      }

    })
    .catch(function (erro) {
      alert(erro);
    });

    // axios.post(urlBase.loopBack + 'Accounts/logout?access_token=' + access_token)
    //   .then(() => {
    //     this.removeLocalStorage();
    //   })
    //   .catch(function () {
    //     this.removeLocalStorage();
    //   }.bind(this));
  }
/*
  downloadPDF(dados)  {
    pdfRedeCredenciada(dados, "download");
  }
  openPDF(dados)  {
    pdfRedeCredenciada(dados,"visualizar");
  }

*/
  render() {
    return (<span>&nbsp;</span>);
  }

  
}


export default RelatorioRedeCredenciada;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/RelatorioRedeCredenciada.js
 **/